import Vue from 'vue';
import VueRouter from 'vue-router';

import MonitorRoutes from './modules/monitor';
import DataAnalysis from './modules/dataAnalysis';
import RemoteControl from './modules/remoteControl';
import Query from './modules/query';
import RamanQuery from './modules/ramanQuery';
import Statistics from './modules/statistics';
import Dashboard from './modules/dashboard';
import Musicbox from './modules/musicbox';
import CiaeRms from './modules/ciaeRms';
import Rg05 from './modules/rg05';
import TaskMonitor from './modules/task';
import TrackMonitor from './modules/trackMonitor';
// import homePage122 from './modules/122HomePage-1';

/**211路由 */
import Air211Monitor from './modules/air-monitor';

/** 呼吸道传染病原体气溶胶监测哨点网络系统路由 */
import RTEAOMonitor from './modules/RTEAO-monitor';

/**无人机路由 */
import droneSystem from './modules/drone';

/**棉花包相关路由 */
import { CottonRoutes } from './modules/cotton';

/**天津消防相关路由 */
import { FirefightingRoutes } from './modules/firefighting';

import Demo from './modules/demo';
import Redirect from './modules/redirect';

import { sortRouter } from './order';

import Layout from '@/layout';
Vue.use(VueRouter);
/**
 * meta 参数
 * key 用来标识路由，参数改变的时候页面刷新
 * bgImg 背景图片
 * headerOptions main头部配置，如下
 * name: 是否展示设备标题,
 * title: 页面标题
 * img: 头部标题背景
 * weather: 标题栏是否有天气
 * menu: 标题栏按钮key
 * order: layout位置
 *
 * noPadding 右侧是否存在padding
 */

let contanstRoutes = [
  Redirect,
  {
    path: '/login',
    component: () => import('@/views/login')
  },
  {
    path: '/404',
    component: () => import('@/views/404')
  },
  {
    path: '/download',
    component: () => import('@/views/client-download')
  },
  {
    path: '/500/:loading?',
    props: true,
    component: () => import('@/views/500')
  },
  {
    path: '/',
    component: Layout
  },
  {
    path: '/temp',
    component: () => import('@/views/temp')
  },
  {
    path: '/error',
    component: Layout,
    name: 'ErrorPages',
    children: [
      {
        path: '404',
        component: () => import('@/views/404'),
        name: 'Page404'
      },
      {
        path: '500',
        component: () => import('@/views/500'),
        name: 'Page500'
      }
    ]
  },
  {
    path: '*',
    meta: { order: 10000 },
    component: () => import('@/views/404')
  }
];

let asyncRoutes = [
  Dashboard,
  DataAnalysis,
  RemoteControl,
  Query,
  Statistics,
  MonitorRoutes,
  CottonRoutes,
  FirefightingRoutes,
  Air211Monitor,
  RTEAOMonitor,
  Musicbox,
  TaskMonitor,
  TrackMonitor,
  CiaeRms,
  Rg05,
  Demo,
  RamanQuery,
  droneSystem
  // homePage122
];

asyncRoutes = sortRouter(asyncRoutes);

const createRouter = () =>
  new VueRouter({
    routes: contanstRoutes
  });

const router = createRouter();

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export { contanstRoutes, asyncRoutes };

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
